import { useLocation, useNavigate } from "react-router-dom";
import { registerNavigator } from "../utils/history";

/*
 * Publishes the router's navigate function to utils/history so non-component
 * code (redux actions) can still navigate. Registered during render so it is
 * available before any child effect fires. Renders nothing.
 */
export default function NavigationBridge() {
  const navigate = useNavigate();
  const location = useLocation();

  registerNavigator(navigate, location);

  return null;
}
